import { render, staticRenderFns } from "./AddEditLoanManagement.vue?vue&type=template&id=157cc506&scoped=true"
import script from "./AddEditLoanManagement.vue?vue&type=script&lang=js"
export * from "./AddEditLoanManagement.vue?vue&type=script&lang=js"
import style0 from "./AddEditLoanManagement.vue?vue&type=style&index=0&id=157cc506&prod&scoped=true&lang=css"
import style1 from "./AddEditLoanManagement.vue?vue&type=style&index=1&id=157cc506&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "157cc506",
  null
  
)

export default component.exports